import script from "./FileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FileModal.vue?vue&type=script&setup=true&lang=js"

import "./FileModal.vue?vue&type=style&index=0&id=0f78741c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f78741c"]])

export default __exports__